module.exports = __webpack_public_path__ + "static/tiffany-03-a1041268a59b76461ffdc505c53facec.jpg";